import { render, staticRenderFns } from "./WizardOverlayContainer.vue?vue&type=template&id=f45cdd40&scoped=true"
import script from "./WizardOverlayContainer.vue?vue&type=script&lang=js"
export * from "./WizardOverlayContainer.vue?vue&type=script&lang=js"
import style0 from "./WizardOverlayContainer.vue?vue&type=style&index=0&id=f45cdd40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45cdd40",
  null
  
)

export default component.exports